export default {"src":"/_next/static/media/Evona.ef85829c.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};